import React from 'react'

import PropTypes from 'prop-types'

import './f-a-q.css'

const FAQ = (props) => {
  return (
    <div className={`f-a-q-accordion ${props.rootClassName} `}>
      <div
        data-role="accordion-container"
        className="f-a-q-element accordion-element"
      >
        <div className="f-a-q-details">
          <span className="f-a-q-text">
            What is sit amet, consectetur adipiscing elit, sed do?
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span data-role="accordion-content" className="f-a-q-text01">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
            officia deserunt mollit anim id est laborum sint occaecat cupidatat
            non proident, sunt in culpa qui officia deserunt mollit anim id.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
      <div
        data-role="accordion-container"
        className="f-a-q-element1 accordion-element"
      >
        <div className="f-a-q-details1">
          <span className="f-a-q-text02">
            We&apos;ll update amet, consectetur adipiscing elit until
            you&apos;re 100% happy.
          </span>
          <span data-role="accordion-content" className="f-a-q-text03">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
            officia deserunt mollit anim id est laborum sint occaecat cupidatat
            non proident, sunt in culpa qui officia deserunt mollit anim id.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon02">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
      <div
        data-role="accordion-container"
        className="f-a-q-element2 accordion-element"
      >
        <div className="f-a-q-details2">
          <span className="f-a-q-text04">
            Is it really sit amet, consectetur adipiscing elit, sed do?
          </span>
          <span data-role="accordion-content" className="f-a-q-text05">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
            officia deserunt mollit anim id est laborum sint occaecat cupidatat
            non proident, sunt in culpa qui officia deserunt mollit anim id.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon04">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
      <div
        data-role="accordion-container"
        className="f-a-q-element3 accordion-element"
      >
        <div className="f-a-q-details3">
          <span className="f-a-q-text06">
            We work, what is sit amet, consectetur adipiscing elit, sed do sint
            occaecat cupidatat non proident
          </span>
          <span data-role="accordion-content" className="f-a-q-text07">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
            officia deserunt mollit anim id est laborum sint occaecat cupidatat
            non proident, sunt in culpa qui officia deserunt mollit anim id.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon06">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
      <div
        data-role="accordion-container"
        className="f-a-q-element4 accordion-element"
      >
        <div className="f-a-q-details4">
          <span className="f-a-q-text08">
            What is sit amet, consectetur adipiscing elit, sed do?
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span data-role="accordion-content" className="f-a-q-text09">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
            officia deserunt mollit anim id est laborum sint occaecat cupidatat
            non proident, sunt in culpa qui officia deserunt mollit anim id.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon08">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
      <div
        data-role="accordion-container"
        className="f-a-q-element5 accordion-element"
      >
        <div className="f-a-q-details5">
          <span className="f-a-q-text10">
            Amet, consectetur adipiscing elit mollit anim id est laborum.
          </span>
          <span data-role="accordion-content" className="f-a-q-text11">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
            officia deserunt mollit anim id est laborum sint occaecat cupidatat
            non proident, sunt in culpa qui officia deserunt mollit anim id.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </div>
        <div data-role="accordion-icon" className="">
          <svg viewBox="0 0 1024 1024" className="f-a-q-icon10">
            <path
              d="M366 708l196-196-196-196 60-60 256 256-256 256z"
              className=""
            ></path>
          </svg>
        </div>
      </div>
    </div>
  )
}

FAQ.defaultProps = {
  rootClassName: '',
}

FAQ.propTypes = {
  rootClassName: PropTypes.string,
}

export default FAQ
